import React from 'react';
import { BodyUnguy } from '~/components/design/bodyUnguy/index';

export type AvatarProps = {
    src: string;
    format?: 'svg' | 'png';
    className?: string;
    style?: React.CSSProperties;
    color?: string;
    name?: string;
    body?: boolean;
};

export function Avatar({ src, format = 'svg', name, className, style, color, body }: AvatarProps) {
    const srcFormat = format === 'svg' ? src.replace('/png', '/svg') : src;

    return (
        <div
            className={className}
            style={{
                ...style,
                position: 'relative',
                width: body ? '60px' : '40px',
                height: body ? '60px' : '40px',
            }}
        >
            <p>
                {/* `ub-mask` : pseudo du joueur masqué dans les enregistrements de session (PostHog). */}
                <span
                    className="ub-mask"
                    style={{
                        position: 'absolute',
                        top: -15,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        color,
                        textAlign: 'center',
                    }}
                >
                    {name}
                </span>
            </p>

            <img
                src={srcFormat}
                alt="avatar"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                }}
            />

            {body && (
                <BodyUnguy
                    color={color}
                    style={{
                        position: 'absolute',
                        top: 12,
                        left: 0,
                        width: '100%',
                        height: '100%',
                    }}
                />
            )}
        </div>
    );
}
